import DefaultProfileImage from "../../../image/defaultProfile.png"; // 이미지 경로에 맞게 수정해주세요.

export default DefaultProfileImage;
